import * as React from 'react';

import { ActionIcon, Group, Text, useMantineTheme } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import dayjs from 'dayjs';
import useDeleteStaffAvailability from 'hooks/staffAvailability/useDeleteStaffAvailability';
import { StaffAvailability } from 'types';
import notificationHandler from 'utils/notifications';

const WeekDayStaffAvailability = ({
  staffAvailability,
  isEditable,
}: {
  staffAvailability: StaffAvailability;
  isEditable: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();
  const { errorNotification } = notificationHandler();

  const deleteStaffAvailabilityMutation = useDeleteStaffAvailability();

  const formattedStartTime = dayjs(staffAvailability.startTime, 'HH:mm:ss').format('h:mm a');
  const formattedEndTime = dayjs(staffAvailability.endTime, 'HH:mm:ss').format('h:mm a');

  const handleDelete = (): void => {
    deleteStaffAvailabilityMutation.mutate(staffAvailability.staffAvailabilityId, {
      onError: error => {
        errorNotification('Availability delete failed', error.response?.data.message);
      },
    });
  };

  return (
    <Group position='left'>
      <Text size='lg' weight={500}>
        {`${formattedStartTime} to ${formattedEndTime}`}
      </Text>
      {isEditable && (
        <ActionIcon size='xl' loading={deleteStaffAvailabilityMutation.isLoading} onClick={handleDelete}>
          <IconTrash size={theme.fontSizes.xl} />
        </ActionIcon>
      )}
    </Group>
  );
};

export default WeekDayStaffAvailability;
